import { useState, useEffect, useMemo } from "react";
import debounce from "debounce";

export function useDebounce(keyword, delay) {
  const [debouncedKeyword, setDebouncedKeyword] = useState("");

  const debouncedSetKeyword = useMemo(
    () =>
      debounce((value) => {
        setDebouncedKeyword(value);
      }, delay),
    [],
  );

  useEffect(() => {
    keyword ? debouncedSetKeyword(keyword) : setDebouncedKeyword("");
  }, [keyword, debouncedSetKeyword]);

  return debouncedKeyword;
}